import React from 'react';
import './Homepage.css';

const SCADAArch = () => {
  return (
    <div className='container-fluid' id='scadaArch-section'>
        <div className="arch-heading">System Architecture for Water Management of SCADA</div>
      <img src="img-data/homepage/scadaArch.jpg" alt="" />
    </div>
  )
}

export default SCADAArch
